import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as actions from '../actions';

import { Spinner } from '@salesforce/design-system-react';
import BrandBand from '../../common/components/BrandBand';
import { Header, TagSettings } from '../components';

export class Settings extends Component {
  renderSpinner() {
    return (
      <div>
        <Spinner variant="brand" />
      </div>
    );
  }

  renderPage() {
    return (
      <BrandBand>
        <Header variant="settings" {...this.props} />
        <TagSettings {...this.props} />
      </BrandBand>
    );
  }

  render() {
    const { isLoading } = this.props.activation;
    return <div>{isLoading ? this.renderSpinner() : this.renderPage()}</div>;
  }
}

Settings.propTypes = {
  activation: PropTypes.object,
  children: PropTypes.element,
  actions: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    activation: state.setup.activation
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
